export var getDefaultStyleSheet = _ref => {
  var {
    hasIcon,
    hasLogo,
    logoSize
  } = _ref;
  return {
    rootStyle: {
      position: 'absolute',
      bottom: 0,
      left: hasLogo ? logoSize === 'small' ? 65 : logoSize === 'medium' ? 75 : 85 : hasIcon ? 55 : 20,
      right: 20
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map